import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { makeStyles, Typography, Container } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import { usePurchasing } from '../../../purchasing'
import { fetchLocation } from '../../slice'
import InventoryStockItemModifyForm from '../InventoryStockItemModifyForm'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('tablet')]: {
      flexDirection: 'row',
    },
  },
  rightBox: {
    flexGrow: 1,
  },
  toolbar: {
    marginBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('mobile')]: {
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  },
  title: {
    color: theme.palette.orange.main,
    fontSize: '1.25rem',
    fontFamily: 'Gotham',
    lineHeight: 1.1,
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up('mobile')]: {
      lineHeight: 1.5,
    },
  },
  skeleton: {
    borderRadius: 10,
    marginTop: 10,
    marginBottom: 9,
  },
}))

const InventoryEditView = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { id } = useParams()
  const { purchasingEnvironment } = usePurchasing()

  const location = useSelector(state => state.buyer.inventory.location)
  const isLoading = useSelector(state => state.buyer.inventory.isLoading)

  console.log(location)

  useEffect(() => {
    dispatch(fetchLocation({ purchasingEnvironment, id }))
  }, [dispatch, purchasingEnvironment, id])

  return (
    <Container className={classes.root}>
      <div className={classes.rightBox}>
        <div className={classes.toolbar}></div>
        {!isLoading && location ? (
          <>
            <Typography className={classes.title}>{location.name}</Typography>
            <InventoryStockItemModifyForm
              items={location.items ?? []}
              location={location}
            />
          </>
        ) : (
          <Skeleton variant="rect" height={150} className={classes.skeleton} />
        )}
      </div>
    </Container>
  )
}

export default InventoryEditView
